import { render, staticRenderFns } from "./BannerShareForm.vue?vue&type=template&id=b1942742"
import script from "./BannerShareForm.vue?vue&type=script&lang=js"
export * from "./BannerShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports